import { ObservableArray, View } from "binder"
import { SearchCustomerViewModel } from "src/Crm/searchCustomer/searchCustomer-viewModel";
import { CustomerTurnOverViewModel, lineItem } from "./customerTurnOver-viewModel"
import { DistrictSelectorViewModel } from "src/EnterpriseAdministration/districtManipulation/districtSelector";

export class CustomerTurnOverView extends View<CustomerTurnOverViewModel>{
    GetViewUniqueId(): string {
        return "V-977B7A8E-F905-4CAD-94FE-F36A46A16F1E"
    }
    loadHtml(): string {
        let element = require('./customerTurnOver.html').default;
        let style = require('./customerTurnOver.less');
        return element;
    }
    constructor() {
       super();
    }

    public set mainDistrictSelectorViewModel(v: DistrictSelectorViewModel) { this._mainDistrictSelectorViewModel = v; } public get mainDistrictSelectorViewModel(): DistrictSelectorViewModel { return this._mainDistrictSelectorViewModel;} private _mainDistrictSelectorViewModel: DistrictSelectorViewModel;
    public set shallChooseMainDistrict(v: boolean) { this._shallChooseMainDistrict = v; } public get shallChooseMainDistrict(): boolean { return this._shallChooseMainDistrict;} private _shallChooseMainDistrict: boolean;

    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from;} private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until;} private _until: moment.Moment;
    public set customerSelector(v: SearchCustomerViewModel) { this._customerSelector = v; } public get customerSelector(): SearchCustomerViewModel { return this._customerSelector;} private _customerSelector: SearchCustomerViewModel;
    
    public set customerName(v: string) { this._customerName = v; } public get customerName(): string { return this._customerName;} private _customerName: string;
    public set customerCode(v: string) { this._customerCode = v; } public get customerCode(): string { return this._customerCode;} private _customerCode: string;
    public set customerId(v: string) { this._customerId = v; } public get customerId(): string { return this._customerId;} private _customerId: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set lineItems(v: ObservableArray<lineItem>) { this._lineItems = v; } public get lineItems(): ObservableArray<lineItem> { return this._lineItems;} private _lineItems: ObservableArray<lineItem>;
    public set remaining(v: string) { this._remaining = v; } public get remaining(): string { return this._remaining;} private _remaining: string;
    public set canPrint(v: boolean) { this._canPrint = v; } public get canPrint(): boolean { return this._canPrint;} private _canPrint: boolean;
    public set credit(v: number) { this._credit = v; } public get credit(): number { return this._credit;} private _credit: number;
    
    calculate(){
        this.dataContext.calculate();
    }
    
    print () {
        this.dataContext.print()
    }
}
